export const getPrevDate = currentDate => {
  return currentDate.clone().subtract(1, "day")
}
